import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { EmailCommunicationService } from '../services/email-communication.service';

export const emailCommunicationPreferencesResolver: ResolveFn<void> = async () => {
  await inject(EmailCommunicationService).getEmailCommunicationPreferences(true);
}
